module.exports = function(e0, e1, e2, e3, phi) {
  return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/mlfn.js
// module id = 99
// module chunks = 0